import { formatElapsed, timeOnLcSeverity, TIME_ON_LC_CLASSES } from '../../utils/timeOnLc';

export interface TimeOnBoardCell {
  display: string;
  className: string;
  tooltip: string;
}

/**
 * Dispatch Planner "Time on Board": how long a row has sat on the board waiting
 * for a driver, counted from the LC finalize stamp (`Order.boardSince`). Same
 * duration format and 12h / 24h / 48h colors as the LC View's "Time on LC".
 * Rows scheduled outside the LC flow carry no stamp and read "-".
 */
export function timeOnBoardCell(boardSince: string | null | undefined, now: Date = new Date()): TimeOnBoardCell {
  const display = formatElapsed(boardSince, now);
  if (display === '-') {
    return { display, className: '', tooltip: 'Not finalized through LC' };
  }
  return {
    display,
    className: TIME_ON_LC_CLASSES[timeOnLcSeverity(boardSince, now)],
    tooltip: `On board since ${new Date(boardSince as string).toLocaleString()}`,
  };
}
